import React from 'react';

import LikertResults from 'js/engines/SurveyAssessment/components/Review/QuestionResults/LikertResults';
import LongTextResults from 'js/engines/SurveyAssessment/components/Review/QuestionResults/LongTextResults';
import MultiSelectResults from 'js/engines/SurveyAssessment/components/Review/QuestionResults/MultiSelectResults';
import { resolveLiveQuestionType } from 'js/utils/sentiment-question';

function getComponent(question) {
  switch (resolveLiveQuestionType(question)) {
    case 'long-text':
      return LongTextResults;

    case 'multi-select':
    case 'single-select':
      return MultiSelectResults;

    case 'likert':
    case 'unscored-likert':
    case 'sentiment':
    default:
      return LikertResults;
  }
}

const QuestionResults = (props) => {
  const ResultsComponent = getComponent(props.question);

  return <ResultsComponent {...props} />;
};

export default QuestionResults;
